import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import BranchIcon from "../../Icons/BranchIcon";
const BranchInvoiceComponent = loadable(
  () => import("../../components/BranchInvoice/BranchInvoiceList")
);

const BranchInvoice = () => {
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <BranchIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Branch Statements
        </span>
      </div>
      <BranchInvoiceComponent />
    </>
  );
};

export default BranchInvoice;
